export function filterInitiativeByCancellationDate(initiative, filter) {
  if (!filter?.fromDate) {
    return true; // No date filter, include the initiative
  }

  const { fromDate } = filter;
  const toDate = filter?.toDate;
  const historyEntries = initiative.history || [];
  const cancellationEntry = historyEntries.find((entry) =>
    (entry.action?.includes('Weekly Status was changed from') &&
      entry.action?.includes('to Cancelled')) ||
    entry.action?.includes('Status update request fully approved by Admin: Status changed to "Cancelled"')
  );

  if (cancellationEntry?.timestamp) {
    const cancellationDate = new Date(cancellationEntry.timestamp);

    if (fromDate && toDate) {
      return cancellationDate >= fromDate._d && cancellationDate <= toDate._d;
    } else if (fromDate) {
      return cancellationDate >= fromDate._d;
    } else if (toDate) {
      return cancellationDate <= toDate._d;
    }
  }
  return !fromDate; // If there's a fromDate, only include if a cancellation within range exists.
}